import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';
import { extendedButtonTheme } from './buttonThemeExtension.js';
import { extendedToggleButtonTheme } from './toggleButtonThemeExtension.js';
import { extendedCheckboxTheme } from './checkboxThemeExtension.js';
import { extendedTextFieldTheme } from './textFieldThemeExtension.js';
import { extentedMenuItemTheme } from './menuItemThemeExtension.js';
import { extendedAccordionTheme } from './accordionThemeExtension.js';
import { extendedRadioTheme } from './radioThemeExtension.js';
import { extendedCardBoundaryTheme } from './cardBoundaryThemeExtension.js';
import { extendedTabTheme } from './tabThemeExtension.js';
import { extendedTabsTheme } from './tabsThemeExtension.js';

const ThemeExtensionContext = createContext({});
function useThemeExtension() {
    return useContext(ThemeExtensionContext);
}
/*
This is the main entry point for the theme extension.
It is used to wrap the entire app, and provides the theme extension context.
The `themeExtension` is an object that can be mixed with an MUI component's `styleOverrides.root` object.
It's the consuming app's responsibility to provide a valid object. This is not validated.
*/
const ThemeExtensionContainer = ({ children, themeExtension, }) => {
    const finalThemeExtension = useMemo(() => {
        const finalButtonTheme = extendedButtonTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Button);
        const finalToggleButtonTheme = extendedToggleButtonTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.ToggleButton);
        const finalCheckboxTheme = extendedCheckboxTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Checkbox);
        const finalTextFieldTheme = extendedTextFieldTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.TextField);
        const finalMenuItemTheme = extentedMenuItemTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.MenuItem);
        const finalAccordionTheme = extendedAccordionTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Accordion);
        const finalCardBoundaryTheme = extendedCardBoundaryTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.CardBoundary);
        const finalRadioTheme = extendedRadioTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Radio);
        const finalTabTheme = extendedTabTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Tab);
        const finalTabsTheme = extendedTabsTheme(themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Tabs);
        return {
            Button: finalButtonTheme,
            ToggleButton: finalToggleButtonTheme,
            Checkbox: finalCheckboxTheme,
            TextField: finalTextFieldTheme,
            MenuItem: finalMenuItemTheme,
            Accordion: finalAccordionTheme,
            CardBoundary: finalCardBoundaryTheme,
            Radio: finalRadioTheme,
            Tab: finalTabTheme,
            Tabs: finalTabsTheme,
        };
    }, [
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Button,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.ToggleButton,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Checkbox,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.TextField,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.MenuItem,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Accordion,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.CardBoundary,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Radio,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Tab,
        themeExtension === null || themeExtension === void 0 ? void 0 : themeExtension.Tabs,
    ]);
    return (jsx(ThemeExtensionContext.Provider, Object.assign({ value: finalThemeExtension }, { children: children })));
};

export { ThemeExtensionContainer, useThemeExtension };
//# sourceMappingURL=index.js.map
